import {
  AmericanExpress,
  BankTranfer,
  Cb,
  Mastercard,
  Paypal,
  VirementBancaire,
  Visa,
} from "../../../../../../../../assets/images/payment";
import { IImageType } from "../../../../../../../../pages/OrderFunnel/Payment/Payment.component";

export const paymentIcons: IImageType[][] = [
  [
    { name: "Cb", url: Cb, width: 55 },
    { name: "Mastercard", url: Mastercard, width: 47 },
    { name: "Visa", url: Visa, width: 41 },
    { name: "AmericanExpress", url: AmericanExpress, width: 48 },
  ],
  [
    { name: "BankTranfer", url: BankTranfer, width: 60 },
    { name: "VirementBancaire", url: VirementBancaire, width: 63 },
    { name: "Paypal", url: Paypal, width: 88 },
  ],
];
